import React, {memo} from 'react';
import Grid from '@material-ui/core/Grid';
import ChartContainer from './ChartContainer';
import ProfitLineChart from './ProfitLineChart';
import RevenueLineChart from './RevenueLineChart';
import SalaryLineChart from './SalaryLineChart';
import BarChart from './BarChart';
import {formatDateToMonthYear} from "../../helpers/dateHelper";
import {setColorsForNames} from "./chartFunctions";

const Charts = ({chartsData, period, renderComment}) => {
    const periodEnd = formatDateToMonthYear(period.end);
    const fullPeriod = `${formatDateToMonthYear(period.start)} - ${periodEnd}`;

    const colorsForNames = setColorsForNames(chartsData);

    return <Grid container>
        <ChartContainer
            chartName='netProfit'
            label='Чистая прибыль'
            period={fullPeriod}
            renderComment={renderComment}
        >
            <ProfitLineChart data={chartsData.netProfit} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='revenue'
            label='Доходы, расходы, прибыль за период'
            period={fullPeriod}
            renderComment={renderComment}
        >
            <RevenueLineChart data={chartsData.revenue} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='productIncomeForPeriod'
            label='Доходы за период'
            period={fullPeriod}
            renderComment={renderComment}
        >
            <BarChart data={chartsData.productIncomeForPeriod} colorsForNames={colorsForNames} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='productIncomeForLastMonth'
            label='Доходы за истекший месяц'
            period={periodEnd}
            renderComment={renderComment}
        >
            <BarChart data={chartsData.productIncomeForLastMonth} colorsForNames={colorsForNames} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='salary'
            label='Доп.аналитика'
            period={fullPeriod}
            renderComment={renderComment}
        >
            <SalaryLineChart data={chartsData.salary} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='expensesForPeriod'
            label='Расходы за период'
            period={fullPeriod}
            renderComment={renderComment}
        >
            <BarChart data={chartsData.expensesForPeriod} colorsForNames={colorsForNames} period={period}/>
        </ChartContainer>
        <ChartContainer
            chartName='expensesForLastMonth'
            label='Расходы за истекший месяц'
            period={periodEnd}
            renderComment={renderComment}
        >
            <BarChart data={chartsData.expensesForLastMonth} colorsForNames={colorsForNames} period={period}/>
        </ChartContainer>
    </Grid>
};

export default memo(Charts);